import React, { useEffect, useRef, useState} from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import globalProducts from './products/globalProducts.json';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

function ProductPage() {
  const { t, i18n } = useTranslation();
  const { productName } = useParams();
  const swiperRef = useRef(null);
  const currentLanguage = i18n.language;
  const [keyExists, setKeyExists] = useState(false);
  const currentUrl = window.location.href;
  const fromWizard = localStorage.getItem('fromWizard');
  const linkDestinationTryFlavour = fromWizard ? '/box' : '/';

  if (fromWizard === "true") {
    localStorage.setItem("hideBoxTitle", "true");
  }
  
  var checkDevice = localStorage.getItem('deviceDetected');
  if (checkDevice === 'mobile') {
    var divToMove = document.querySelector('.result__col.result__col--right.swiper-container');
        var targetDiv = document.querySelector('.suggest');
        if (divToMove && targetDiv) {
            targetDiv.parentNode.insertBefore(divToMove, targetDiv.nextSibling);
        }
  }

  useEffect(() => {
    var checkDevice = localStorage.getItem('deviceDetected');
    if (checkDevice === 'mobile') {
        var headerWhite = document.querySelector('.wrap-header');
        headerWhite.classList.remove('box-header');
        headerWhite.classList.add('white-header');
        var divToMove = document.querySelector('.result__col.result__col--right.swiper-container');
        var targetDiv = document.querySelector('.suggest');
        if (divToMove && targetDiv) {
            targetDiv.parentNode.insertBefore(divToMove, targetDiv.nextSibling);
        }
        console.log("first case: updated");
    }

    setKeyExists(true);
    console.log("refreshed")
  }, []);

  useEffect(() => {
    if (currentUrl.includes("/men-") || currentUrl.includes("/c-men-")) {
      localStorage.setItem('selectedGender', 'MEN');
    } else if (currentUrl.includes("/women-") || currentUrl.includes("/c-women-")) {
        localStorage.setItem('selectedGender', 'WOMEN');
    }
  })

  const productInfo = globalProducts?.[productName];
  const imagePath = productInfo && productInfo.choco_color ? `./img/cioccolatini/${productInfo.choco_color}.png` : null;
  const imagePath2 = productInfo && productInfo.choco_color_2 ? `./img/cioccolatini/${productInfo.choco_color_2}.png` : null;  
  const imageCiocco = productInfo ? require(`${imagePath}`): null;

  useEffect(() => {
    if (productInfo) {
      swiperRef.current = new Swiper('.result-slider', {
        direction: window.innerWidth > 1100 ? 'vertical' : 'horizontal',
        touchEventsTarget: 'container',
        touchStartPreventDefault: false,
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },
        breakpoints: {
          1100: {
            direction: 'vertical',
            pagination: false,
          },
        },
      });

      const handleResize = () => {
        if (swiperRef.current) {
          swiperRef.current.changeDirection(window.innerWidth > 1100 ? 'vertical' : 'horizontal');
        }
      };

      window.addEventListener('resize', handleResize);

      return () => {
        swiperRef.current?.destroy();
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [productInfo]);

  // ANALYTICS START
  var detectCurrentDevice = localStorage.getItem('deviceDetected');
  useEffect(() => {

    const formatProductTitle = (title) => {
      return title
        .toLowerCase() // Convert to lowercase
        .replace(/ & /g, ' and ') // Replace '&' with 'and'
        .replace(/\s+/g, '-'); // Replace spaces with underscores
    };

    window.tc_vars = {
      'channel': detectCurrentDevice,
      'environment': "stg",
      'pagetemplate': "Valentino Lovely Courting Experience: Product Page",
      'site_languagecode': currentLanguage,
      '404': false,
      'pagename': `V:${currentLanguage}:valentine:product:${formatProductTitle(productInfo.title_en)}`
    };
    console.log("!!! window.tc_vars", window.tc_vars)
    // V:it.valentine:product:mini logo moon bag in nappa leather with chain
    window._satellite.track('virtual_page_load', window.tc_vars);

    console.log("tc_vars", window.tc_vars);
    console.log("virtual_page_load", "activated");
  }, []);
  // ANALYTICS END

  let imageCiocco2 = null;
  if (imagePath2) {
    imageCiocco2 = require(`${imagePath2}`);
  }
  const shopClickEvent = () => {
    /* global _satellite */
    window._satellite.track('digitalcatalog', {
      'event': 'choose_your_store'
    });
    console.log("window._satellite.track", "choose_your_store");
  }

  const differentFlovourClickEvent = () => {
    /* global _satellite */
    window._satellite.track('digitalcatalog', {
      'event': 'try_different_flavour'
      });
    console.log("window._satellite.track", "try_different_flavour");
  }

  return (
    <div className="wrapper wrapper--page wrapper--page-result">
      <div className="wrap">
        <div className="container">
          <div className="result">
            <div className="result__col result__col--left">
              <div className="result__desc">
                {currentLanguage === 'en' && <h1>{productInfo.title_en}</h1>}
                {currentLanguage === 'kr' && <h1>{productInfo.title_kr}</h1>}
                {currentLanguage === 'jp' && <h1>{productInfo.title_jp}</h1>}
                {currentLanguage === 'cn' && <h1>{productInfo.title_cn}</h1>}
              </div>
              <div className='result_product_desc'>
                {currentLanguage === 'en' && <p className='product-desc'>{productInfo.description_product.En}</p>}
                {currentLanguage === 'kr' && <p className='product-desc'>{productInfo.description_product.Kr}</p>}
                {currentLanguage === 'jp' && <p className='product-desc'>{productInfo.description_product.Jp}</p>}
                {currentLanguage === 'cn' && <p className='product-desc'>{productInfo.description_product.Cn}</p>}  
              </div>
 
                <div className="result__meta">
                  <div className="suggest">
                    {currentLanguage === 'en' && <p>{productInfo.introduction_product.En}</p>}
                    {currentLanguage === 'kr' && <p>{productInfo.introduction_product.Kr}</p>}
                    {currentLanguage === 'jp' && <p>{productInfo.introduction_product.Jp}</p>}
                    {currentLanguage === 'cn' && <p>{productInfo.introduction_product.Cn}</p>}  
                  </div>
                  <h2>{productInfo.description_general}</h2>
                  <p>{t('PRODUCT_WANT_TAKE_FRASE')}</p>
                </div>
                <div className="result__actions result-actions">
                  <div className="result-actions__item">
                    <Link to="/shops" className="result-actions__btn btn" onClick={shopClickEvent}>
                      {t('SELECT_YOUR_SHOP')}
                    </Link>
                  </div>
                  <div className="result-actions__item"> 
                    <Link to={linkDestinationTryFlavour} className="result-actions__btn btn btn--red js-go-page" onClick={differentFlovourClickEvent}>
                      {t('TRY_DIFF_FLAV_FRASE')}
                    </Link>
                  </div>
                </div>
            </div>
            
            <div className="result__col result__col--right swiper-container">
              
              <div className="swiper result-slider">
              <div className="swiper-wrapper result-slider__wrap">
                {productInfo.galleryImages.map((image, index) => (
                  <div key={index} className="swiper-slide result-slider__item">
                    <a href={image.link} target="_blank" rel="noreferrer">
                      <picture className="result-slider__img">
                      <img src={image.link} width={683} height={899} alt="" />
                      </picture>
                    </a>
                  </div>
                ))}
              </div>
              <div className="swiper-pagination" />
            </div>
            {productInfo.choco_color && (
              <img src={require(`./img/cioccolatini/${productInfo.choco_color}.png`)} className="cioccolatino" alt=""/>
            )}
            {productInfo.choco_color_2 && (
              <img src={require(`./img/cioccolatini/${productInfo.choco_color_2}.png`)} className="cioccolatino-2" alt=""/>
            )}
            </div>
          </div>
          <div className="like">{t('LIKE_PRODUCT_FRASE')}</div>
        </div>
      </div>
      <div className="preload">
        <picture className="preload__cta-img">
          <img src="img/logo-big.svg" alt="" width={160} height={89} />
        </picture>
      </div>
      <div className="overflow-bg" />
    </div>
  );
}

export default ProductPage;
